import React, { Component } from 'react';
import ReactDOM from 'react-dom';

import ProjectTrack from '~/components/legacy/ProjectTrack.jsx';
import { parseReactProps } from '~/components/legacy/reactProps.js';
import legacyEventHub from '~/modules/legacyRuntime.js';

class ProjectTrackListing extends Component {
  constructor(props) {
    super(props);

    this.state = {
      active_track_id: props.active_track_id || 0,
      activeTrackVariantId: '',
      cart_items: props.cart_items || [],
      data: Array.isArray(props.data) ? props.data : [],
      projectTrackTotalCount: Number.isInteger(props.projectTrackTotalCount) ? props.projectTrackTotalCount : (Array.isArray(props.data) ? props.data.length : 0),
      showUsageLicenseSelectForTrackId: []
    };
    this.eventHubListeners = [];

    this.handleCartClick = this.handleCartClick.bind(this);
    this.handleProjectTrackRemoved = this.handleProjectTrackRemoved.bind(this);
    this.handleProjectTrackVariantRemoved = this.handleProjectTrackVariantRemoved.bind(this);
    this.handleUpdateCart = this.handleUpdateCart.bind(this);
    this.handleClosePopupMenus = this.handleClosePopupMenus.bind(this);
    this.handleUsageLicenseTypeSelectClose = this.handleUsageLicenseTypeSelectClose.bind(this);
  }

  componentDidMount() {
    this.registerEventHubListener('updateCart', this.handleUpdateCart);
    this.registerEventHubListener('closePopupMenus', this.handleClosePopupMenus);
  }

  componentWillUnmount() {
    this.eventHubListeners.forEach((listener) => {
      if (legacyEventHub && typeof legacyEventHub.off === 'function') {
        legacyEventHub.off(listener.eventName, listener.handler);
      }
    });
    this.eventHubListeners = [];
  }

  registerEventHubListener(eventName, handler) {
    this.eventHubListeners = this.eventHubListeners || [];
    if (!legacyEventHub || typeof legacyEventHub.on !== 'function') {
      return;
    }

    legacyEventHub.on(eventName, handler);
    this.eventHubListeners.push({ eventName, handler });
  }

  triggerEventHub(eventName, ...args) {
    if (legacyEventHub && typeof legacyEventHub.trigger === 'function') {
      legacyEventHub.trigger(eventName, ...args);
    }
  }

  handleUpdateCart(data) {
    const payload = Array.isArray(data) ? data[0] : data;
    this.setState({ cart_items: payload && payload.items ? payload.items : (Array.isArray(payload) ? payload : []) });
  }

  handleClosePopupMenus() {
    this.setState({ showUsageLicenseSelectForTrackId: [] });
  }

  handleCartClick(trackId) {
    if (this.state.showUsageLicenseSelectForTrackId.indexOf(trackId) === -1) {
      this.setState({ showUsageLicenseSelectForTrackId: [trackId] });
      return;
    }

    this.triggerEventHub('closePopupMenus');
  }

  handleUsageLicenseTypeSelectClose(trackId) {
    this.setState({
      showUsageLicenseSelectForTrackId: this.state.showUsageLicenseSelectForTrackId.filter((openTrackId) => openTrackId !== trackId)
    });
  }

  pauseIfPlayingTrack(trackId, trackVariantId = null) {
    const audioPlayer = window.AudioPlayer;
    const currentTrackId = audioPlayer?.currentTrackData?.id;
    const currentVariantId = audioPlayer?.currentTrackVariantId;
    const isMatchingTrack = String(currentTrackId) === String(trackId);
    const isMatchingVariant = trackVariantId === null || String(currentVariantId) === String(trackVariantId);

    if (isMatchingTrack && isMatchingVariant && audioPlayer?.playing && typeof audioPlayer.pausePlayer === 'function') {
      audioPlayer.pausePlayer();
    }
  }

  handleProjectTrackRemoved(trackId, projectTrackCount) {
    this.pauseIfPlayingTrack(trackId);
    const nextData = this.state.data.filter((track) => track.id !== trackId);
    const nextTotalCount = Number.isInteger(projectTrackCount) ? projectTrackCount : Math.max(0, this.state.projectTrackTotalCount - 1);

    this.setState({
      data: nextData,
      projectTrackTotalCount: nextTotalCount,
      showUsageLicenseSelectForTrackId: this.state.showUsageLicenseSelectForTrackId.filter((openTrackId) => openTrackId !== trackId)
    });

    const countTarget = this.props.projectTrackCountSelector && document.querySelector(this.props.projectTrackCountSelector);
    if (countTarget) {
      const template = nextTotalCount === 1 ? countTarget.dataset.singular : countTarget.dataset.plural;
      countTarget.textContent = template.replace('%{count}', nextTotalCount);
    }
  }

  trackIsInCart(trackId) {
    return this.state.cart_items.some((item) => item.track_id === trackId);
  }

  handleProjectTrackVariantRemoved(projectTrackId, projectTrackVariantId, trackVariantId) {
    this.pauseIfPlayingTrack(projectTrackId, trackVariantId);
    this.setState((state) => ({
      data: state.data.map((track) => {
        if (track.id !== projectTrackId) {
          return track;
        }

        return {
          ...track,
          track_variants: (track.track_variants || []).filter((variant) => variant.project_track_variant_id !== projectTrackVariantId)
        };
      })
    }));
  }

  trackProps(track) {
    const usageLicenseTypes = Array.isArray(this.props.usageLicenseTypes) ? this.props.usageLicenseTypes.filter((usageLicenseType) => usageLicenseType.for_fx === false) : [];

    return {
      add_to_cart: this.props.i18n.add_to_cart,
      allowedProjectLicenseFamilyKeys: track.allowed_project_license_family_keys,
      cart_items: this.state.cart_items,
      composerName: track.composer_name,
      discount: track.discount,
      display_title: track.display_title,
      free: track.free,
      freeMode: this.props.freeMode,
      handleCartClick: this.handleCartClick,
      handleUsageLicenseTypeSelectClose: this.handleUsageLicenseTypeSelectClose,
      i18n: this.props.i18n,
      id: track.id,
      inCart: this.trackIsInCart(track.id),
      included_media_bundles: track.included_media_bundles,
      length: track.length,
      locale: this.props.locale,
      onProjectTrackRemoved: this.handleProjectTrackRemoved,
      onProjectTrackVariantRemoved: this.handleProjectTrackVariantRemoved,
      projectTrackAvailable: track.project_track_available,
      projectTrackAvailabilityLabel: track.project_track_availability_label,
      projectTrackRemoveEnabled: this.props.projectTrackRemoveEnabled !== false,
      projectTrackRemoveFullLabel: true,
      projectTrackRemovePath: track.project_track_remove_path,
      pricing_path: this.props.pricing_path,
      trackDetailPath: track.track_detail_path,
      title: track.title,
      track_variants: Array.isArray(track.track_variants) ? track.track_variants : [],
      licenseNavigatorPath: this.props.licenseNavigatorPath,
      showUsageLicenseSelect: this.state.showUsageLicenseSelectForTrackId.indexOf(track.id) > -1,
      show_download_button: this.props.show_download_button,
      subscribedUsageLicenseTypes: this.props.subscribedUsageLicenseTypes,
      track_image_markup: track.track_image,
      usageLicenseTypes,
      waveform_inactive: track.waveform_inactive,
      waveform_loaded: track.waveform_loaded,
      waveform_played: track.waveform_played
    };
  }

  emptyState() {
    if (this.state.projectTrackTotalCount > 0) {
      return (
        <div className='customer-project-detail__summary' role='status'>
          <h3>{this.props.locale === 'de' ? 'Keine passenden Titel gefunden.' : 'No matching titles found.'}</h3>
          <p>{this.props.locale === 'de' ? 'Passen Sie Ihre Suche an oder setzen Sie die Filter zurück.' : 'Adjust your search or reset the filters.'}</p>
          <a className='button button--ghost' href={this.props.projectFilteredEmptyPath}>{this.props.locale === 'de' ? 'Filter zurücksetzen' : 'Reset filters'}</a>
        </div>
      );
    }

    return (
      <div className='customer-project-detail__summary' role='status'>
        <h3>{this.props.locale === 'de' ? 'Noch keine Titel gespeichert.' : 'No titles saved yet.'}</h3>
        <p>{this.props.locale === 'de' ? 'Speichern Sie Titel aus dem Katalog, um Ihre private Musiksammlung hier aufzubauen.' : 'Save titles from the catalog to build your private collection here.'}</p>
        <a className='button' href={this.props.projectEmptyStatePath}>{this.props.locale === 'de' ? 'Musik suchen' : 'Find music'}</a>
      </div>
    );
  }

  render() {
    if (this.state.data.length === 0) {
      return this.emptyState();
    }

    return (
      <div className='project-track-listing'>
        <div className='project-track-listing__header' aria-hidden='true'>
          <span></span>
          <span>{this.props.locale === 'de' ? 'Track' : 'Track'}</span>
          <span>{this.props.locale === 'de' ? 'Waveform' : 'Waveform'}</span>
          <span>{this.props.locale === 'de' ? 'Aktionen' : 'Actions'}</span>
        </div>
        {this.state.data.map((track) => (
          <div className='project-track-listing__item' key={`project-track-item-${track.id}`}>
            <ProjectTrack {...this.trackProps(track)} />
          </div>
        ))}
      </div>
    );
  }
}

ProjectTrackListing.defaultProps = {
  cart_items: [],
  data: [],
  freeMode: false,
  i18n: { add_to_cart: 'Lizenz' },
  locale: 'de',
  projectTrackTotalCount: 0,
  projectTrackRemoveEnabled: true,
  show_download_button: false,
  subscribedUsageLicenseTypes: [],
  usageLicenseTypes: []
};

const elements = document.querySelectorAll('[data-react-component=ProjectTrackListing]');

elements.forEach((element) => {
  ReactDOM.render(
    <React.StrictMode>
      <ProjectTrackListing {...parseReactProps(element.dataset.reactProps)} />
    </React.StrictMode>,
    element
  );
});

export default ProjectTrackListing;
